<template>
  <div>
    <div class="activity_boxs">
      <el-carousel indicator-position="outside"
                   style="width:100%"
                   arrow="never"
                   height="420px">
        <el-carousel-item v-for="(x,y) in list"
                          :key="y+'x'">
          <div class="activity_list">
            <div class="activity_items"
                 :style="{'width':'calc((100% - 60px) /'+ 4 +')'}"
                 @click="toActivity(item)"
                 v-for="(item,index) in  x"
                 :key="index">
              <el-image style="width:100%; height: 164px;border-radius: 10px 10px 0 0;"
                        :src="item.owCoverPicture"></el-image>
              <!-- XW_ty.jpg  item.owCoverPicture-->
              <div class="activity_content">
                <div class="activity_item_title">{{item.title}}</div>
                <div class="flexCenter"
                     style="color:#666666">
                  <!-- <div style="flex:1">{{item.startTime}}-{{item.endTime}}·{{item.address}}</div> -->
                  <div style="flex:1">{{item.briefIntroduction}}</div>
                  <!-- <div class="mainColor font16"
                       v-if="item.remainNum && item.remainNum>0">仅剩{{item.remainNum}}名额</div> -->
                </div>
                <div class="flexStart"
                     style="margin:0">
                  <!-- <div style="flex:1;color:#999999;font-size:14px">主讲老师：{{item.lectureName}}</div> -->
                  <el-button type="text"
                             size="mini"
                             class="mainColor"
                             round>立即查看>></el-button>
                  <!-- <div style="font-weight: 400;">{{ item.createTime }}</div> -->
                </div>

              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
      default: {
        return: []
      }
    }
  },
  data () {
    return {
      url: 'https://img0.baidu.com/it/u=410476708,2625048454&fm=253&fmt=auto&app=120&f=JPEG?w=1280&h=800'
    }
  },
  methods: {
    toActivity (item) {
      window.open(item.wxUrl)
    }
  }
}
</script>
<style lang="less" scoped>
.activity_boxs {
  width: 1200px;
  margin: 0 auto;
  .activity_top {
    display: flex;
    .activity_title {
      flex: 1;
    }
  }
  .activity_list {
    width: 100%;
    display: flex;
    margin: 20px 0;
    .activity_items {
      background-color: #fff;
      margin-right: 20px;
      border-radius: 10px;
      cursor: pointer;
      .activity_content {
        padding: 10px;
        box-sizing: border-box;
        .activity_item_title {
          width: 100%;
          color: #333333;
          font-size: 18px;
          font-weight: bold;
          text-overflow: ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .flexCenter {
          margin: 16px 0 20px 0;
        }
      }
    }
    .activity_items:nth-child(4) {
      margin-right: 0;
    }
  }
}
</style>